import { Component } from '@angular/core';
import { ProviderService } from '../../provider.service';
import { IProvider, PROVIDER_TTL_ES } from '../../provider.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-provider',
  templateUrl: './provider.component.html'
})
export class ProviderComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private serviceBase: ProviderService) {
    super(PROVIDER_TTL_ES, serviceBase);
  }

  ngOnInit() {
    this.table.settings = {
      title: PROVIDER_TTL_ES,
      columns: [
        { header: 'RUC', field: 'ruc' },
        { header: 'Nombre', field: 'name' },
        { header: 'Dirección', field: 'address' },
        { header: 'N° telef.', field: 'mobile' },
        { header: 'Email', field: 'email' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProvider[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
